import RestartAltIcon from "@mui/icons-material/RestartAlt";
import {
  Box,
  Chip,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomRangePicker from "../../../components/dateRange";
import AppHeader from "../../../components/header";
import Label from "../../../components/label/index";
import AppLoader from "../../../components/loader";
import PerformanceGraphs from "../../../components/performanceGraph";
import StatsCard from "../../../components/statsCard";
import {
  resetDashboardSearchFilter,
  resetDashboardSearchFilterSaver,
  setDashboardEndDate,
  setDashboardEndDateSaver,
  setDashboardStartDate,
  setDashboardStartDateSaver,
  setSelectedAgentsSaver,
} from "../../../lib/redux/slices/searchKeysSlice";
import { getAllAgents } from "../../../services/AgentApi";
import { getAdminDashboard } from "../../../services/DashboardApi";
import { handleOpenSnackBar } from "../../../utils/helper";
import CompletedConnection from "./Connections";

const tableHeader = [
  "Agent Details",
  "User ID",
  "Password",
  "Designation",
  "Actions",
];

const displayRows = [
  "agent_details",
  "agent_email",
  "agent_password",
  "designation",
  "actions",
];

const dropDownStyle = {
  display: "flex",
  overflowY: "auto",
  gap: 0.5,

  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
    display: "none",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "primary.main",
    // borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "secondary.dark",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "text.coolGrey",
  },
};

const SuperAdminSaverDashboardPage = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [allAgents, setAllAgents] = useState([]);
  const [dashboardData, setDashboardData] = useState(null);
  const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);

  useEffect(() => {
    handleFetchAllGents();
  }, []);

  useEffect(() => {
    fetchAdmintDashboard(
      searchKeys?.selectedAgentsSaver,
      searchKeys?.dashboardStartDateSaver,
      searchKeys?.dashboardEndDateSaver,
      searchKeys?.selectedCardStatusSaver,
    );
  }, [searchKeys?.selectedCardStatusSaver]);

  const fetchAdmintDashboard = async (ids, sd, ed, sb) => {
    let query = {
      startDate: sd.toISOString(),
      endDate: ed.toISOString(),
      pricingMode: "buy",
    };
    try {
      setIsLoading(true);
      const response = await getAdminDashboard(ids, query, sb);
      if (response?.data.status === "success") {
        let data = response?.data.data;
        setDashboardData(data);
      } else {
        handleOpenSnackBar("error", response?.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFetchAllGents = async () => {
    try {
      setIsLoading(true);
      const response = await getAllAgents();
      if (response?.data.status === "success") {
        let data = response.data.data;
        setAllAgents(data);
      } else {
        handleOpenSnackBar("error", response?.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilterByDate = () => {
    fetchAdmintDashboard(
      searchKeys?.selectedAgentsSaver,
      searchKeys?.dashboardStartDateSaver,
      searchKeys?.dashboardEndDateSaver,
      searchKeys?.selectedCardStatusSaver,
    );
  };

  const handleResetFilter = () => {
    dispatch(resetDashboardSearchFilterSaver());
    fetchAdmintDashboard(
      [],
      moment(new Date()),
      moment(new Date()),
      searchKeys?.selectedCardStatusSaver,
    );
  };

  let cardData = [
    {
      id: 1,
      title: "Signed",
      count: dashboardData?.totalSignedContracts || 0,
      type: "signedContract",
    },
    {
      id: 2,
      title: "GP Sold",
      count: `£${dashboardData?.totalProfit || 0}`,
      type: "gpSold",
    },

    // {
    //   id: 3,
    //   title: "GP In Provisioning",
    //   count: `£${dashboardData?.gpInProvisioning || 0}`,
    //   type: "gpProvisioning",
    // },

    // {
    //   id: 4,
    //   title: "GP Lost",
    //   count: `£${dashboardData?.gpLoss || 0}`,
    //   type: "gpLost",
    // },

    {
      id: 5,
      title: "Total Live Sales",
      count: dashboardData?.totalLiveSale || 0,
      type: "liveSales",
    },

    {
      id: 6,
      title: "GP Live",
      count: `£${dashboardData?.totalNetProfit || 0}`,
      type: "gpLive",
    },
    // {
    //   id: 7,
    //   title: "Rework",
    //   count: `${dashboardData?.gpInRework || 0}`,
    //   type: "gpInRework",
    // },

    // {
    //   id: 8,
    //   title: "Sales Lost",
    //   count: `${dashboardData?.salesLost || 0}`,
    //   type: "salesLost",
    // },

    // {
    //   id: 9,
    //   title: "Contracts Sent",
    //   count: dashboardData?.totalContracts || 0,
    //   type: "sendContract",
    // },

    // {
    //   id: 10,
    //   title: "GP Live to Target",
    //   count: `${dashboardData?.netProfitTargetPercentage || 0}%`,
    //   type: "gpLiveToTarget",
    // },

    // {
    //   id: 11,
    //   title: "GP Lost %",
    //   count: `${dashboardData?.gpLossTargetPercentage || 0}%`,
    //   type: "gpLostPercent",
    // },
  ];

  return (
    <AppHeader>
      <AppLoader isVisible={isLoading} />
      <Stack
        my={4}
        gap={2}
        direction={{ md: "row" }}
        alignItems={{ md: "center" }}
        justifyContent={"space-between"}
      >
        <Stack>
          <Typography
            variant="primaryText"
            component={"h1"}
            fontSize={{ xs: "1.5rem", md: "2.125rem" }}
          >
            Saver Dashboard
          </Typography>
        </Stack>

        <Stack
          direction={{ xs: "column-reverse", sm: "row" }}
          alignItems={"flex-end"}
          gap={{ xs: 1, sm: 2 }}
        >
          {/* filter tabs */}

          <Box width={{ xs: "100%", md: 250 }}>
            <Label title={"select agents"} style={{ fontSize: "0.75rem" }} />
            <Select
              fullWidth
              size="small"
              multiple
              value={searchKeys?.selectedAgentsSaver}
              onChange={(e) => {
                dispatch(setSelectedAgentsSaver(e.target.value));
              }}
              renderValue={(selected) => (
                <Box sx={{ ...dropDownStyle }}>
                  {selected.map((id, index) => {
                    const agent = allAgents.find((agent) => agent._id === id);
                    return <Chip key={id} label={agent?.username} />;
                  })}
                </Box>
              )}
            >
              {allAgents.map((val, index) => (
                <MenuItem key={index} value={val._id}>
                  {val.username}
                </MenuItem>
              ))}
            </Select>
          </Box>
          <CustomRangePicker
            startDate={searchKeys?.dashboardStartDateSaver}
            endDate={searchKeys?.dashboardEndDateSaver}
            setStartDate={(start) =>
              dispatch(setDashboardStartDateSaver(start))
            }
            setEndDate={(start) => dispatch(setDashboardEndDateSaver(start))}
            handleFilterDate={handleFilterByDate}
            stackProps={{
              boxShadow: "rgba(0, 0, 0, 0.09) 0px 3px 12px",
              borderRadius: "6px",
            }}
          />
          <IconButton
            onClick={handleResetFilter}
            sx={{
              borderRadius: "10px",
              background: (theme) => theme.palette.gradient.button,
              marginBottom: "8px",
            }}
          >
            <RestartAltIcon htmlColor="white" />
          </IconButton>
        </Stack>
      </Stack>

      {/* seller states */}
      <Grid container rowSpacing={2} columnSpacing={6}>
        {cardData.map((itemmm, index) => {
          return (
            <Grid key={index} item xs={12} sm={6} md={3}>
              <StatsCard title={itemmm.title} valueCount={itemmm.count} />
            </Grid>
          );
        })}
      </Grid>

      {/* performance graph */}

      <PerformanceGraphs dashboardData={dashboardData} />
      {/* <PerformancePieChart dashboardData={dashboardData} > */}

      {/* Completed Contracts List */}

      <CompletedConnection
        allContracts={dashboardData?.allContracts}
        cardsData={cardData}
      />
    </AppHeader>
  );
};

export default SuperAdminSaverDashboardPage;
